export default {
  BACK_TO_SIGN_IN: 'Back to sign in',
  CAMPAIGNS_NAV_LABEL: 'Campaigns',
  COLLAPSE_NAV: 'Collapse Navigation',
  EXPAND_NAV: 'Expand Navigation',
  CONSTITUENTS_NAV_LABEL: 'Constituents',
  CONTACTS_NAV_LABEL: 'Contacts',
  DONORS_NAV_LABEL: 'Donors',
  EDIT_PROFILE: 'Edit Profile',
  ERROR_LOGGING_OUT: 'Error logging out',
  HELP_LINK: 'Help',
  SEND_FEEDBACK_LINK: 'Send Feedback',
  HOME_NAV_LABEL: 'Home',
  OPPORTUNITIES_NAV_LABEL: 'Opportunities',
  INTEGRATIONS_NAV_LABEL: 'Apps & Extensions',
  INTEGRATIONS_NAV_LABEL_NEW: 'Integrations',
  LIFECYCLE_BOARDS: 'Lifecycle Boards',
  NAVIGATION_PRIMARY: 'Primary Navigation',
  SETTINGS_LABEL: 'Settings',
  SUPER_ADMIN_NAV_LABEL_NEW: 'Super Admin',
  PRIVACY_LINK: 'Legal',
  REPORTS_NAV_LABEL: 'Reports',
  TASKS_NAV_LABEL: 'Tasks',
  TOGGLE_SIDEBAR: 'Toggle Sidebar',
  ICON_COLLAPSE: 'Collapse Sidebar Icon',
  ICON_EXPAND: 'Expand Sidebar Icon',
  ICON_INSTIL_LOGO: 'Instil Logo',
  ICON_INSTIL_LOGO_ICON: 'Instil Icon',
  ICON_USER_PROFILE_ARROW: 'User Profile Arrow Icon',
  USER_INFO: 'User Information',
};
